export enum LocationType {
	Continent = 1,
	Sea = 2,
	Mountain = 3,
	Country = 101,
	Region = 102,
	District = 103,
	SubDistrict = 104,
	Settlement = 201,
	SettlementsRegion = 202,
	SettlementsMicroRegion = 203,
}

export const hasWeatherForLocationTypes = [
	LocationType.Settlement,
	LocationType.SettlementsRegion,
	LocationType.SettlementsMicroRegion,
];
